export default __webpack_public_path__ + "static/media/030-no turn right.acbc461d.png";